import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../config/axios';
import DesignAssetEditor from './DesignAssetEditor';
import EmailEditor from './EmailEditor';

/**
 * ContentEditor - Smart router that selects the appropriate editor based on content type
 */
export default function ContentEditor() {
  const { id } = useParams<{ id: string }>();
  const [contentType, setContentType] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContentType = async () => {
      if (!id) return;

      try {
        const response = await axiosInstance.get(`/content/${id}`);
        setContentType(response.data.type);
      } catch (error) {
        console.error('Failed to load content type:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchContentType();
  }, [id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Route to appropriate editor based on content type
  if (contentType === 'email') {
    return <EmailEditor />;
  }

  // Default to DesignAssetEditor for design, graphic, and other visual content
  return <DesignAssetEditor />;
}
